module.exports = __webpack_public_path__ + "media/bootstrap-icons/fonts-bd0fb5ff.svg";